import ProductDisplaySection from './ProductDisplaySection'

export default ProductDisplaySection
